export default "__VITE_ASSET__Cbn3OlP$__";